<template lang="pug">
#card-analise-socioambiental-operacao
    BaseHeader(
        titulo='Análise de Protocolo Socioambiental',
        voltarPara='emit',
        @voltarClicado='fechar()',
        :exibeBotao='false'
    )

    section.card-analise-socioambiental-operacao__body
        div(
            v-for='(diagnosticoProtocolo, index) in diagnosticosProtocolo',
            :key='index',
            @click='$refs.modalResultadoDiagnosticoRef.abrirModal(diagnosticoProtocolo)'
        )
            .card-analise-socioambiental-operacao__body__item(
                :class='status[diagnosticoProtocolo.status].classeCollapse'
            )
                .d-flex.align-items-center
                    i.card-analise-socioambiental-operacao__body__item__icone(
                        :class='status[diagnosticoProtocolo.status].classeIcone'
                    )
                    .font-weight-bold {{ diagnosticoProtocolo.nome }}

                i.el-icon-arrow-right.el-icon--right.card-analise-socioambiental-operacao__body__item--acao

    section.card-analise-socioambiental-operacao__aprovar-recusar(
        v-if='habilitarAnalise'
    )
        h2 Situação

        el-form(label-position='top', size='small')
            el-form-item.mt-2
                el-radio-group(v-model='escolhaAprovarReprovar')
                    el-radio.mr-4(label='Aprovar')
                    el-radio(label='Reprovar')

            el-form-item.mt-1(v-if='opcaoReprovarAtiva')
                div(slot='label', style='display: grid')
                    span.campo_obrigatorio Motivo

                    el-select(
                        v-model='motivosReprovacaoSelecao',
                        multiple,
                        clearable
                    )
                        el-option(
                            v-for='{ nome, id } in motivosReprovacao',
                            :key='nome',
                            :label='nome',
                            :value='id'
                        )

            el-form-item
                div(slot='label')
                    span(v-if='opcaoReprovarAtiva', style='color: red') *
                    span Justificativa

                    el-tooltip(
                        v-if='opcaoReprovarAtiva',
                        content='Para confirmar a reprovação de cadastro da operação, insira uma justificativa abaixo. Esta opção não poderá ser alterada.',
                        placement='right',
                        effect='light'
                    )
                        i.mdi.mdi-information-outline.ml-2

                el-input(
                    v-model='justificativaAprovarReprovar',
                    :maxlength='255',
                    placeholder='Justificativa',
                    type='textarea',
                    resize='none',
                    :rows='2'
                )

    section.card-analise-socioambiental-operacao__acao(v-if='habilitarAnalise')
        el-button.mr-2(size='small', @click='fechar()')
            | Voltar

        el-button(
            @click='aprovarRecusarOperacao()',
            type='primary',
            size='small'
        )
            | Finalizar análise

    section.card-analise-socioambiental-operacao__acao(v-else)
        el-button(size='small', @click='fechar()')
            | Voltar

        el-button(
            v-if='habilitarBotaoCadastrar',
            @click='cadastrarOperacao()',
            type='primary',
            size='small'
        )
            | {{ editandoOperacao ? 'Salvar' : 'Cadastrar operação' }}

    ModalResultadoDiagnostico(ref='modalResultadoDiagnosticoRef')
</template>

<script>
import BaseHeader from '@/components/BaseHeader.vue';
import ModalResultadoDiagnostico from '@/components/operacao/gestao/ModalResultadoDiagnostico.vue';
import DiagnosticoSocioambientalService from '@/services/DiagnosticoSocioambientalService';
import OperacaoService from '@/services/OperacaoService';

export default {
    name: 'CardAnaliseSocioambientalOperacao',
    components: { BaseHeader, ModalResultadoDiagnostico },
    emits: [
        'aprovarOperacao',
        'reprovarOperacao',
        'fechar',
        'cadastrarOperacao'
    ],

    props: {
        dadosDiagnostico: {
            type: Object,
            required: true
        },
        editandoOperacao: {
            type: Boolean,
            required: false,
            default: false
        },
        habilitarBotaoCadastrar: {
            type: Boolean,
            required: false,
            default: true
        },
        habilitarAnalise: {
            type: Boolean,
            required: false,
            default: false
        }
    },

    computed: {
        opcaoReprovarAtiva() {
            return this.escolhaAprovarReprovar === 'Reprovar';
        }
    },

    data() {
        return {
            diagnosticosProtocolo: [],
            escolhaAprovarReprovar: 'Aprovar',
            status: {
                ALERTA: {
                    classeIcone: 'alerta flow flow-warning-sign'
                },
                SUCESSO: {
                    classeIcone: 'sucesso el-icon-circle-check'
                },
                ATENCAO: {
                    classeIcone: 'atencao flow flow-warning-sign'
                }
            },
            justificativaAprovarReprovar: null,
            mostrarDialogCamadas: false,
            mostrarCardAprovarReprovar: false,
            motivosReprovacao: [],
            motivosReprovacaoSelecao: []
        };
    },

    async mounted() {
        await this.realizarDiagnosticoListagem();
        await this.buscarMotivosReprovacao();
    },

    methods: {
        async aprovarRecusarOperacao() {
            const payload = {
                justificativa: this.justificativaAprovarReprovar,
                motivos: this.motivosReprovacaoSelecao
            };

            if (this.escolhaAprovarReprovar === 'Reprovar') {
                if (
                    this.justificativaAprovarReprovar == null ||
                    this.justificativaAprovarReprovar.length === 0
                ) {
                    this.$notify.warning({
                        message: 'Preencha a justificativa.'
                    });
                    return;
                }

                if (this.motivosReprovacaoSelecao.length === 0) {
                    this.$notify.warning({
                        message: 'Escolha os motivos para reprovação.'
                    });
                    return;
                }

                this.$emit('reprovarOperacao', payload);
            } else {
                this.$emit('aprovarOperacao', payload);
            }
        },

        async buscarMotivosReprovacao() {
            await OperacaoService.buscarMotivosReprovacao()
                .then(({ data }) => {
                    this.motivosReprovacao = data.itens;
                })
                .catch(() => {
                    this.$notify.error({
                        message:
                            'Ocorreu um erro ao buscar os motivos para reprovação. Tente novamente.'
                    });
                });
        },

        cadastrarOperacao() {
            this.$emit('cadastrarOperacao');
        },

        async realizarDiagnosticoListagem() {
            await DiagnosticoSocioambientalService.realizarDiagnosticoSocioambientalProtocolo(
                this.dadosDiagnostico
            )
                .then(({ data }) => {
                    this.diagnosticosProtocolo = data;
                })

                .catch(erro => {
                    this.$notify.error({
                        message:
                            'Ocorreu um erro ao realizar Análise de Protocolo Socioambiental. Tente novamente.'
                    });
                    this.fechar();
                });
        },

        fechar() {
            this.$emit('fechar');
        }
    }
};
</script>

<style lang="scss">
#card-analise-socioambiental-operacao {
    .card-analise-socioambiental-operacao__body {
        gap: 2px;
        display: flex;
        flex-direction: column;
        margin: 20px;

        .card-analise-socioambiental-operacao__body__item {
            height: 75px;
            background-color: var(--white);
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: space-between;
            border-radius: $default-border-radius;
            transition: 0.3s ease-in-out;

            .card-analise-socioambiental-operacao__body__item__icone {
                font-size: 24px;
                margin: 0 15px;
            }

            .card-analise-socioambiental-operacao__body__item--acao {
                height: 100%;
                display: flex;
                justify-content: center;
                align-items: center;
                font-size: 18px;
                margin-right: 20px;
            }

            .alerta {
                color: #df675b;
            }

            .sucesso {
                color: var(--secondary-two);
            }

            .atencao {
                color: #d7bc25;
            }
        }

        .card-analise-socioambiental-operacao__body__item:hover {
            opacity: 0.7;
        }
    }

    .card-analise-socioambiental-operacao__acao {
        display: flex;
        justify-content: space-between;
        margin: 20px;
    }

    .card-analise-socioambiental-operacao__aprovar-recusar {
        background-color: var(--white);
        margin: 20px;
        padding: 20px;
        border-radius: $default-border-radius;
    }

    .campo_obrigatorio::before {
        content: '* ';
        color: red;
    }
}
</style>
